import { useMutation } from '..';
import permissions from '../Apollo/permissions';
import { mutation, buildVariables } from './update-webhook-config-mutation-builder';
import { QUERY_WEBHOOK_CONFIG } from './query-webhook-config-builder';

export default function useUpdateWebhookConfig({ onCompleted, ...options } = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.updateWebhookConfig },
    successMsg: 'Webhook Configuration updated.',
    refetchQueries: [{ query: QUERY_WEBHOOK_CONFIG }],
    onCompleted: data => {
      if (onCompleted) onCompleted(data.update_webhook_config);
    },
    ...options,
  });

  const updateWebhookConfig = ({ webhookConfigId, url, eventTypes, enabled }) =>
    executeMutation({ variables: buildVariables({ webhookConfigId, url, eventTypes, enabled }) });

  return [updateWebhookConfig, response];
}
